import fixedBottomComponents from './fixedBottomComponents.vue'
const fixedBottom = {
  install: (Vue) => {
    Vue.component('fixedBottomComponents', fixedBottomComponents)
  }
}
export default fixedBottom
